export default __webpack_public_path__ + "static/media/GQ.ad0ccfc2.svg";